import { render } from "./RegisterSuccess.vue?vue&type=template&id=035054dc&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"

import "./RegisterSuccess.vue?vue&type=style&index=0&id=035054dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035054dc"]])

export default __exports__